import React, { useLayoutEffect } from 'react';
import { useParams } from 'umi';
import { PAGE_CONFIG } from './pageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { getStudioAdCreativesFilterInstanceId } from '../components/AdCreativesWrapper/types';
import { clearStudioFilterStorageByInstance } from '../utils/studioFilterStorage';

function clearAdCreativesFilterStorage() {
  const tabs = PAGE_CONFIG?.children?.[0]?.config?.tabs ?? [];
  tabs.forEach((tab: { key: string; }) => {
    clearStudioFilterStorageByInstance(getStudioAdCreativesFilterInstanceId(tab.key));
  });
}

const AdCreatives = () => {
  const { gameCode, studioId } = useParams<{ gameCode?: string; studioId?: string; }>() || {};

  // 路由级生命周期：进入/离开 AdCreatives 页时清理各 Tab 的 Studio 专用筛选缓存
  useLayoutEffect(() => {
    clearAdCreativesFilterStorage();
    return () => {
      clearAdCreativesFilterStorage();
    };
  }, []);

  return (
    <CommonPageRender
      key={`${gameCode}-${studioId}`}
      reqParams="/adCreatives"
      frameType="game"
      // @ts-ignore
      pageConfigInit={PAGE_CONFIG}
      api={PAGE_CONFIG_API}
    />
  );
};

export default AdCreatives;
